module.exports = __webpack_public_path__ + "img/tower.e1996a69.png";